<template>
    <v-row justify="center">
      <v-dialog v-model="intDialogVisible" width="30%">
        <v-card color="#f0f0f0">
          <v-row justify="center">
            <v-col cols="12"  sm="12">
              <v-img :src="img"></v-img>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeModal(true)">
              {{ $t('Headers.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script>/**
 * @vue-prop {String} title - page title
 * @vue-prop {String} data - page data
 * @vue-prop {Boolean} dialog - sets dialog visible
 * @vue-computed {} get() - returns the dialog
 * @vue-computed {String} set(value) - sets dialog
 * @vue-event {String} closeModal(status) - sends status to vuex store
 */
import i18n from "../../../i18n";


export default {
  name: "preview-modal",
  title: i18n.t('Headers.Vorschau'),
  props: {
    title: String,
    img: String,
    dialog: Boolean,
  },
  computed: {
    intDialogVisible: {
      get: function () {
        return this.dialog
      },
      set: function (value) {
        this.dialog = value
      },
    }
  },
  methods: {
    closeModal(status) {
      if (status) {
        this.$emit('setCloseModal', true)
      }
    }
  }
}
</script>
